import { Suspense } from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import AppRoutes from "./routes/AppRoutes";
import { useLocation } from "react-router-dom";
import ProgressWrap from "./components/progressWrap";
// import CookieConsent from "./components/CookieConsent";
const App = () => {
  const location = useLocation();

  const definedRoutes = [
    "/",
    "/privacy-policy",
    "/terms-conditions",
    "/contact-us",
  ];
  const isPageNotFound = !definedRoutes.includes(location.pathname);

  return (
    <Suspense fallback={"Loading..."}>
      {!isPageNotFound && <Header />}

      {/* <CookieConsent /> */}
      <div
        style={{ minHeight: isPageNotFound ? "100vh" : "calc(100vh - 5.375rem)" }}
        className="overflow-hidden"
      >
        <AppRoutes />
      </div>
      {!isPageNotFound && <ProgressWrap />}
      {!isPageNotFound && (
        <>{location.pathname == "/support" ? <Footer /> : <Footer />}</>
      )}
    </Suspense>
  );
};
export default App;
